var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTclogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280.161,
    height: 51.035,
    viewBox: "0 0 280.161 51.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#274794",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979",
    transform: "translate(-157.253 -182.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Type",
    transform: "translate(179.232 182.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M205.622,198.723h-2.7a1.321,1.321,0,0,1-1.261-1.321v-4.082A1.247,1.247,0,0,1,202.92,192h2.7v-7.685a1.374,1.374,0,0,1,1.322-1.321h4.924a1.282,1.282,0,0,1,1.261,1.321V192h6.484a1.3,1.3,0,0,1,1.322,1.321V197.4a1.374,1.374,0,0,1-1.322,1.321h-6.484v12.489c0,1.862.9,2.281,2.281,2.281a18.324,18.324,0,0,0,4.2-.9,1.069,1.069,0,0,1,1.561.721l.781,3.662a1.352,1.352,0,0,1-.781,1.621,21.9,21.9,0,0,1-7.805,1.8c-6.184,0-7.746-4.143-7.746-8.946Z",
    transform: "translate(-201.659 -182.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M258.351,199.975a12.433,12.433,0,0,1,12.728,12.849,18.043,18.043,0,0,1-.12,1.8,1.409,1.409,0,0,1-1.321,1.261H251.866a6.664,6.664,0,0,0,6.9,6.424,9.2,9.2,0,0,0,5.944-2.041c.66-.54,1.381-.6,1.8,0l2.341,3.122a1.169,1.169,0,0,1-.12,1.8,15.664,15.664,0,0,1-10.327,3.782c-8.286,0-14.05-6.6-14.05-14.53C244.361,206.64,250.125,199.975,258.351,199.975Zm5.163,10.988a5.069,5.069,0,0,0-5.344-4.8c-3.362,0-5.523,2.041-5.884,4.8Z",
    transform: "translate(-223.225 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M304.286,201.9a1.332,1.332,0,0,1,1.321-1.321h2.161a1.076,1.076,0,0,1,1.141.781l1.02,2.642a10.547,10.547,0,0,1,8.466-4.022c4.023,0,6,1.441,8.286,4.2a11.839,11.839,0,0,1,8.946-4.2c8.886,0,10.987,5.644,10.987,12.849v14.17a1.346,1.346,0,0,1-1.38,1.32h-4.8a1.332,1.332,0,0,1-1.321-1.32v-14.35c0-3.6-1.322-5.824-4.8-5.824-4.022,0-5.163,2.882-5.163,2.882s.119,1.381.119,2.642v14.65a1.373,1.373,0,0,1-1.32,1.32h-4.924a1.3,1.3,0,0,1-1.321-1.32v-14.35c0-3.6-1.02-5.824-4.562-5.824-3.423,0-4.683,2.4-5.344,4.322v15.851a1.374,1.374,0,0,1-1.321,1.32h-4.863a1.373,1.373,0,0,1-1.321-1.32Z",
    transform: "translate(-253.49 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M412.451,228.974a20.615,20.615,0,0,1-6.665-1.14v13.449a1.421,1.421,0,0,1-1.322,1.321H399.6a1.374,1.374,0,0,1-1.322-1.321V201.9a1.333,1.333,0,0,1,1.322-1.321h2.221c.661,0,1.081.541,1.321,1.321l.721,2.221a11.975,11.975,0,0,1,9.066-4.143c7.566,0,13.27,6.124,13.27,14.53C426.2,222.61,420.737,228.974,412.451,228.974Zm-6.665-8.405a10.97,10.97,0,0,0,5.764,1.561c4.563,0,6.905-3.723,6.905-7.625s-2.222-7.685-6.545-7.685a6.361,6.361,0,0,0-6.124,3.842Z",
    transform: "translate(-300.962 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M474.675,199.975A13.737,13.737,0,0,1,485,204.658c.6.6.3,1.381-.3,1.981l-2.521,2.762c-.6.661-1.261.36-1.8-.18a7.554,7.554,0,0,0-5.523-2.4,7.277,7.277,0,0,0-7.325,7.624c0,4.323,2.942,7.686,7.266,7.686a7.343,7.343,0,0,0,5.883-3.062,1.3,1.3,0,0,1,1.742-.18l2.7,2.282c.661.6.961,1.261.48,1.981a12.417,12.417,0,0,1-10.987,5.824,14.5,14.5,0,1,1,.059-29Z",
    transform: "translate(-332.115 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M528.041,199.975a14.5,14.5,0,1,1-14.17,14.41A14.415,14.415,0,0,1,528.041,199.975Zm0,22.155a7.519,7.519,0,0,0,7.265-7.746,7.242,7.242,0,1,0-14.47,0A7.471,7.471,0,0,0,528.041,222.13Z",
    transform: "translate(-359.34 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M569.8,202.809c-.421-.841-.06-1.622.96-1.622h5.7a1.279,1.279,0,0,1,1.26.781l5.764,13.689h.121l6.124-13.689c.36-.721.961-.781,1.741-.781h5.043a1.011,1.011,0,0,1,.961,1.622l-12.488,26.057a1.412,1.412,0,0,1-1.2.72h-.36a1.409,1.409,0,0,1-1.2-.72Z",
    transform: "translate(-387.498 -192.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M638.915,199.975a12.433,12.433,0,0,1,12.729,12.849c0,.42-.06,1.381-.119,1.8a1.411,1.411,0,0,1-1.321,1.261H632.429a6.665,6.665,0,0,0,6.9,6.424,9.2,9.2,0,0,0,5.945-2.041c.661-.54,1.38-.6,1.8,0l2.341,3.122a1.169,1.169,0,0,1-.121,1.8,15.66,15.66,0,0,1-10.326,3.782c-8.286,0-14.05-6.6-14.05-14.53C624.925,206.64,630.689,199.975,638.915,199.975Zm5.164,10.988a5.069,5.069,0,0,0-5.344-4.8c-3.362,0-5.524,2.041-5.884,4.8Z",
    transform: "translate(-415.427 -191.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M685.043,201.9a1.332,1.332,0,0,1,1.322-1.321h2.221a1.162,1.162,0,0,1,1.2.9l1.021,2.7a9.635,9.635,0,0,1,7.8-4.2c3.3,0,6,.9,5.224,2.7l-1.8,4.083a1.164,1.164,0,0,1-1.621.6,5.528,5.528,0,0,0-2.582-.54,6.025,6.025,0,0,0-5.283,2.882v17.292c0,1.021-.661,1.32-1.562,1.32h-4.623a1.374,1.374,0,0,1-1.322-1.32Z",
    transform: "translate(-445.79 -191.569)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(157.253 190.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 2.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 25.02,
    height: 2.721,
    transform: "translate(0 5.411)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 25.02,
    height: 2.721,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 8.352,
    height: 2.018,
    transform: "translate(25.592 9.905)",
    fill: "#041e5d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(20.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M220.716,203.339h0c0-3.924-2.187-4.08-3.156-4.189-1.161-.13-1.969-.223-2.518-.264-.4-.03-2.529-.505-3.6-.651a29.887,29.887,0,0,0-6.1,0c-.766.128-2.368.709-3.4.981-1.082.285-1.65.161-2.105.492-.956.692-.906,3.59-.906,4.091,0,0-.05,2.909.906,3.6.711.516,3.629.714,9.024.714h8.707c.913,0,3.151.027,3.156-4.506h0v-.268Z",
    transform: "translate(-198.921 -198.077)",
    fill: "#a2bc1e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M202.7,206.422a16.214,16.214,0,0,1-.213-2.5,10.736,10.736,0,0,1,.253-2.32.7.7,0,0,1,.57-.573l2.523-.8c.263-.11.447.13.409.38,0,0-.161,1.347-.161,2.225a20.253,20.253,0,0,0,.165,2.134c.041.25-.13.428-.407.582l-2.6,1.262C202.925,206.964,202.737,206.673,202.7,206.422Z",
    transform: "translate(-200.723 -199.152)",
    fill: "#264694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M217.03,213.2h-7.465c-1.5,0-1.509-.729-.028-1.2a11.584,11.584,0,0,1,3.178-.369C216.491,211.634,218.526,213.2,217.03,213.2Z",
    transform: "translate(-203.726 -204.924)",
    fill: "#264694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M227.62,206.541a.453.453,0,0,1-.651.248l-2.43-1.314a.745.745,0,0,1-.392-.678,20.559,20.559,0,0,0,.2-2.361,23.69,23.69,0,0,0-.2-2.452.327.327,0,0,1,.393-.405l2.545.542a.61.61,0,0,1,.542.5,9.766,9.766,0,0,1,.379,2.923A10.94,10.94,0,0,1,227.62,206.541Z",
    transform: "translate(-211.658 -198.832)",
    fill: "#264694"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M207.767,217.4c0,.494-.769.9-1.717.9s-1.717-.4-1.717-.9.769-.9,1.717-.9S207.767,216.91,207.767,217.4Z",
    transform: "translate(-201.654 -207.386)",
    fill: "#264694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M233.139,217.4c0,.494-.769.9-1.718.9s-1.717-.4-1.717-.9.769-.9,1.717-.9S233.139,216.91,233.139,217.4Z",
    transform: "translate(-214.468 -207.386)",
    fill: "#264694"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTclogo);
export default __webpack_public_path__ + "static/media/tclogo.7eb3d55c94fffd7102afd8d829036ce2.svg";
export { ForwardRef as ReactComponent };